module.exports = __webpack_public_path__ + "img/logopk2.a7c0877f.png";